import { appConfig } from 'config'

export const cdnUrlFromPath = (pathname?: string | null) =>
  pathname ? new URL(pathname, appConfig.cdnURL).href : undefined

export const imageUrlFromPath = (pathname?: string | null) =>
  pathname ? new URL(pathname, appConfig.imageURL).href : undefined
